import { h, Component } from 'preact';
import { trackingProvider, DIMENSION } from '@cube/track';
import Google from '../providers/google.js';
import SemShopping from '../providers/semshopping.js';

@trackingProvider({
	[DIMENSION.componentpath]: 'SerpSwitcher'
})
export default class SerpSwitcher extends Component {

	render({ provider, ...props }){
		if (provider === 'semshopping') return <SemShopping {...props} />;

		return <Google {...props} />;
	}
}
